<template>
  <div>
    <box>
      <v-card flat>
        <v-card-text>
          <div v-if="isLoading" class="text-center ma-12">
            <v-progress-circular size="48" width="4" indeterminate color="grey lighten-2"></v-progress-circular>
          </div>

          <template v-else-if="!isLoading">
            <v-row dense style="max-width: 640px;"  no-gutters>
              <v-col cols="12">
                <BoxItem :title="$t('BUNDLE_GROUPS-DETAIL-NAME')" :value="item.name" @updateValue="item.name = $event" />
              </v-col>
              <v-col cols="6">
                <BoxItem
                  :title="$t('BUNDLE_GROUP-LABEL-WIDTH')"
                  :value="item.attributes.width"
                  type="number"
                  min="0"
                  :hint="item.average_values.width ? 'average value: ' + Number(item.average_values.width.toFixed(1)) : ''"
                  @updateValue="item.attributes.width = $event"
                />
              </v-col>

              <v-col cols="6">
                <BoxItem
                  :title="$t('BUNDLE_GROUP-LABEL-HEIGHT')"
                  :value="item.attributes.height"
                  type="number"
                  min="0"
                  :hint="item.average_values.height ? 'average value: ' + Number(item.average_values.height.toFixed(1)) : ''"
                  @updateValue="item.attributes.height = $event"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <BoxItem
                  :title="$t('BUNDLE_GROUP-LABEL-LENGTH')"
                  :hint="item.average_values.length ? 'average value: ' + Number(item.average_values.length.toFixed(1)) : ''"
                  :value="item.attributes.length"
                  type="number"
                  min="0"
                  @updateValue="item.attributes.length = $event"
                />

              </v-col>

              <v-col cols="12" sm="6">
                <BoxItem
                  :title="$t('BUNDLE_GROUP-LABEL-WEIGHT')"
                  :hint="item.average_values.weight ? 'average value: ' + Number(item.average_values.weight.toFixed(1)) : ''"
                  :value="item.attributes.weight"
                  type="number"
                  min="0"
                  @updateValue="item.attributes.weight = $event"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <BoxItem
                  :title="$t('BUNDLE_GROUP-LABEL-WIDTH_BAR')"
                  :hint="item.average_values.width_bars ? 'average value: ' + Number(item.average_values.width_bars.toFixed(1)) : ''"
                  :value="item.attributes.width_bars"
                  type="number"
                  min="0"
                  @updateValue="item.attributes.width_bars = $event"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <BoxItem
                  :title="$t('BUNDLE_GROUP-LABEL-LENGTH_BAR')"
                  :hint="item.average_values.length_bars ? 'average value: ' + Number(item.average_values.length_bars.toFixed(1)) : ''"
                  :value="item.attributes.length_bars"
                  type="number"
                  min="0"
                  @updateValue="item.attributes.length_bars = $event"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <BoxItem
                  :title="$t('BUNDLE_GROUP-LABEL-AREA_PRESSURE')"
                  :hint="item.average_values.area_pressure ? 'average value: ' + Number(item.average_values.area_pressure.toFixed(1)) : ''"
                  :value="item.attributes.area_pressure"
                  @updateValue="item.attributes.area_pressure = $event"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <BoxItem
                  :title="$t('BUNDLE_GROUP-LABEL-ADP_PROGRAM')"
                  :value="item.attributes.adp_program"
                  @updateValue="item.attributes.adp_program = $event"
                />
              </v-col>
            </v-row>

            <SubHeader :text="$t('BUNDLE_GROUP-LABEL-TOLERANCES')"></SubHeader>
            <v-form style="max-width: 640px;">
              
              <v-row dense class="d-flex align-center">
                <v-col cols="6" class="d-flex align-center">
                  <BoxItem
                  :title="$t('BUNDLE_GROUP-LABEL-TOLERANCES-WIDTH_PLUS')"
                  :value="item.attributes.tolerance_width_plus"
                  type="number"
                  min="0"
                  oninput="if(!Number.isInteger(Number(this.value)) || Number(this.value) < 0) this.value = 0;"
                  @updateValue="item.attributes.tolerance_width_plus = $event"
                />
                </v-col>
                <v-col cols="6" >
                  <BoxItem
                  :title="$t('BUNDLE_GROUP-LABEL-TOLERANCES-WIDTH_MINUS')"
                  :value="item.attributes.tolerance_width_minus"
                  type="number"
                  min="0"
                  oninput="if(!Number.isInteger(Number(this.value)) || Number(this.value) < 0) this.value = 0;"
                  @updateValue="item.attributes.tolerance_width_minus = $event"
                />
                </v-col>
              </v-row>
              <v-row dense class="d-flex align-center">
                <v-col cols="6" class="d-flex align-center" >
           
                  <BoxItem
                  :title="$t('BUNDLE_GROUP-LABEL-TOLERANCES-LENGTH_PLUS')"
                  :value="item.attributes.tolerance_length_plus"
                  type="number"
                  min="0"
                  oninput="if(!Number.isInteger(Number(this.value)) || Number(this.value) < 0) this.value = 0;"
                  @updateValue="item.attributes.tolerance_length_plus = $event"
                />
                </v-col>
                <v-col cols="6">
                  <BoxItem
                  :title="$t('BUNDLE_GROUP-LABEL-TOLERANCES-LENGTH_MINUS')"
                  :value="item.attributes.tolerance_length_minus"
                  type="number"
                  min="0"
                  oninput="if(!Number.isInteger(Number(this.value)) || Number(this.value) < 0) this.value = 0;"
                  @updateValue="item.attributes.tolerance_length_minus = $event"
                />
                </v-col>
              </v-row>
 
              <v-row dense class="d-flex align-center">
                
                <v-col cols="6" class="d-flex align-center">

                  <BoxItem
                  :title="$t('BUNDLE_GROUP-LABEL-TOLERANCES-HEIGHT_PLUS')"
                  :value="item.attributes.tolerance_height_plus"
                  type="number"
                  min="0"
                  oninput="if(!Number.isInteger(Number(this.value)) || Number(this.value) < 0) this.value = 0;"
                  @updateValue="item.attributes.tolerance_height_plus = $event"
                />
                </v-col>
                <v-col cols="6" >
                  <BoxItem
                  :title="$t('BUNDLE_GROUP-LABEL-TOLERANCES-HEIGHT_MINUS')"
                  :value="item.attributes.tolerance_height_minus"
                  type="number"
                  min="0"
                  oninput="if(!Number.isInteger(Number(this.value)) || Number(this.value) < 0) this.value = 0;"
                  @updateValue="item.attributes.tolerance_height_minus = $event"
                />
                </v-col>
              </v-row>
            </v-form>

            <v-divider class="my-4" style="border: none;"></v-divider>
          </template>
        </v-card-text>
      </v-card>
    </box>
    <box class="mt-2" background="transparent" borderColor="transparent" padding="1em 0">
      <div class="d-flex justify-end">
        <v-btn color="secondary" :loading="isSaving" bottom right @click="save()" style="z-index:999;">
          <lang t="GLOBAL-BTN-SAVE" />
        </v-btn>
      </div>
    </box>
  </div>
</template>

<script>
import Box from "../../../components/ui-elements/Box.vue";
import BoxItem from "../../../components/ui-elements/BoxItem.vue";
import SubHeader from "../../../components/ui-elements/SubHeader.vue";
import { converterMixin } from "../../../mixins/converterMixin";
import {cloneDeep} from 'lodash';
 
export default {
  components: {
    Box,
    BoxItem,
    SubHeader
  },
  mixins:[converterMixin],
  data() {
    return {
      isSaving: false,
      isLoading: true,
      item: {
        name: null,
        attributes: {},
        bundles: null,
      },
      defaultItem:{
        attributes: {},
        average_values: {}
      }
    };
  },

  created() {
    this.initialize();
  },

  watch: {},
  computed: {},
  methods: {
    initialize() {
      this.axios.get(`bundlegroups/${this.$route.params.id}`).then((res) => {
        this.item = cloneDeep(res.data);
        this.item.attributes.width = res.data.attributes.width ?? null;
        this.item.attributes.height = res.data.attributes.height ?? null;
        this.item.attributes.length = res.data.attributes.length ?? null;
        this.item.attributes.weight = res.data.attributes.weight ?? null;

        this.item.attributes.width_bars = res.data.attributes.width_bars ?? null;
        this.item.attributes.length_bars = res.data.attributes.length_bars ?? null;
        this.item.attributes.area_pressure = res.data.attributes.area_pressure ?? null;
        this.item.attributes.adp_program = res.data.attributes.adp_program ?? null;

        this.item.average_values.width = res.data.average_values.width ?? null;
        this.item.average_values.height = res.data.average_values.height ?? null;
        this.item.average_values.length = res.data.average_values.length ?? null;
        this.item.average_values.weight = res.data.average_values.weight ?? null;
        this.item.average_values.width_bars = res.data.average_values.width_bars ?? null;
        this.item.average_values.length_bars = res.data.average_values.length_bars ?? null;

        this.item.attributes.tolerance_width_plus = res.data.attributes.tolerance_width_plus ?? null;
        this.item.attributes.tolerance_width_minus = res.data.attributes.tolerance_width_minus ?? null;
        this.item.attributes.tolerance_length_plus = res.data.attributes.tolerance_length_plus ?? null;
        this.item.attributes.tolerance_length_minus = res.data.attributes.tolerance_length_minus ?? null;
        this.item.attributes.tolerance_height_plus = res.data.attributes.tolerance_height_plus ?? null;
        this.item.attributes.tolerance_height_minus = res.data.attributes.tolerance_height_minus ?? null;

        if(!this.isMetricUnitSystem){
            if(this.item.attributes.width){
              this.item.attributes.width = this.milimetersToInch(res.data.attributes.width);
            }
            if(this.item.attributes.height){
              this.item.attributes.height = this.milimetersToInch(res.data.attributes.height);
            }
            if(this.item.attributes.length){
              this.item.attributes.length = this.milimetersToInch(res.data.attributes.length);
            }
            if(this.item.attributes.weight){
              this.item.attributes.weight = this.gramsToLb(res.data.attributes.weight);
            }
            if(this.item.attributes.width_bars){
              this.item.attributes.width_bars = this.milimetersToInch(res.data.attributes.width_bars);
            }
            if(this.item.attributes.length_bars){
              this.item.attributes.length_bars = this.milimetersToInch(res.data.attributes.length_bars);
            }
            if(this.item.average_values.width){
              this.item.average_values.width = this.milimetersToInch(res.data.average_values.width);
            }
            if(this.item.average_values.height){
              this.item.average_values.height = this.milimetersToInch(res.data.average_values.height);
            }
            if(this.item.average_values.length){
              this.item.average_values.length = this.milimetersToInch(res.data.average_values.length);
            }
            if(this.item.average_values.weight){
              this.item.average_values.weight = this.gramsToLb(res.data.average_values.weight);
            }
            if(this.item.average_values.width_bars){
              this.item.average_values.width_bars = this.milimetersToInch(res.data.average_values.width_bars);
            }
            if(this.item.average_values.length_bars){
              this.item.average_values.length_bars = this.milimetersToInch(res.data.average_values.length_bars);
            }

            if(this.item.attributes.tolerance_width_plus){
              this.item.attributes.tolerance_width_plus = this.milimetersToInch(res.data.attributes.tolerance_width_plus);
            }

            if(this.item.attributes.tolerance_width_minus){
              this.item.attributes.tolerance_width_minus = this.milimetersToInch(res.data.attributes.tolerance_width_minus);
            }

            if(this.item.attributes.tolerance_length_minus){
              this.item.attributes.tolerance_length_minus = this.milimetersToInch(res.data.attributes.tolerance_length_minus);
            }

            if(this.item.attributes.tolerance_length_plus){
              this.item.attributes.tolerance_length_plus = this.milimetersToInch(res.data.attributes.tolerance_length_plus);
            }

            if(this.item.attributes.tolerance_height_plus){
              this.item.attributes.tolerance_height_plus = this.milimetersToInch(res.data.attributes.tolerance_height_plus);
            }

            if(this.item.attributes.tolerance_height_minus){
              this.item.attributes.tolerance_height_minus = this.milimetersToInch(res.data.attributes.tolerance_width_minus);
            }
        }

        this.defaultItem = cloneDeep(this.item);

        this.changeTitle(res.data);
        this.isLoading = false;
      });
    },

    changeTitle(itemObj) {
      this.$route.meta.pageTitle = this.$t("SETTINGS-BUNDLE_GROUP-DETAIL-HEADING") + " " + itemObj.name;

      // Add a temporary query parameter.
      this.$router.replace({ query: { temp: Date.now() } });

      // Remove the temporary query parameter.
      this.$router.replace({ query: { temp: undefined } });
    },

    save() {
      const item = cloneDeep(this.item);
      if(!this.isMetricUnitSystem){
            if(item.attributes.width && item.attributes.width !== this.defaultItem.attributes.width){
              this.defaultItem.attributes.width = cloneDeep(item.attributes.width);
              item.attributes.width = this.inchToMilimeters(item.attributes.width);
            }else{
              delete item.attributes.width;
            }

            if(item.attributes.height && item.attributes.height !== this.defaultItem.attributes.height){
              this.defaultItem.attributes.height = cloneDeep(item.attributes.height);
              item.attributes.height = this.inchToMilimeters(item.attributes.height);
            }else{
              delete item.attributes.height;
            }

            if(item.attributes.length && item.attributes.length !== this.defaultItem.attributes.length){
              this.defaultItem.attributes.length = cloneDeep(item.attributes.length);
              item.attributes.length = this.inchToMilimeters(item.attributes.length);
            }else{
              delete item.attributes.length;
            }

            if(item.attributes.weight && item.attributes.weight !== this.defaultItem.attributes.weight){
              this.defaultItem.attributes.weight = cloneDeep(item.attributes.weight);
              item.attributes.weight = this.lbToGrams(item.attributes.weight);
            }else{
              delete item.attributes.weight;
            }

            if(item.attributes.width_bars && item.attributes.width_bars !== this.defaultItem.attributes.width_bars){
              this.defaultItem.attributes.width_bars = cloneDeep(item.attributes.width_bars);
              item.attributes.width_bars = this.inchToMilimeters(item.attributes.width_bars);
            }else{
              delete item.attributes.width_bars;
            }

            if(item.attributes.length_bars && item.attributes.length_bars !== this.defaultItem.attributes.length_bars){
              this.defaultItem.attributes.length_bars = cloneDeep(item.attributes.length_bars);
              item.attributes.length_bars = this.inchToMilimeters(item.attributes.length_bars);
            }else{
              delete item.attributes.length_bars;
            }

            delete item.average_values;
            

            if(item.attributes.tolerance_width_plus && item.attributes.tolerance_width_plus !== this.defaultItem.attributes.tolerance_width_plus){
              this.defaultItem.attributes.tolerance_width_plus = cloneDeep(item.attributes.tolerance_width_plus);
              item.attributes.tolerance_width_plus = this.inchToMilimeters(item.attributes.tolerance_width_plus);
            }else{
              delete item.attributes.tolerance_width_plus;
            }

            if(item.attributes.tolerance_width_minus && item.attributes.tolerance_width_minus !== this.defaultItem.attributes.tolerance_width_minus){
              this.defaultItem.attributes.tolerance_width_minus = cloneDeep(item.attributes.tolerance_width_minus);  
              item.attributes.tolerance_width_minus = this.inchToMilimeters(item.attributes.tolerance_width_minus);
            }else{
              delete item.attributes.tolerance_width_minus;
            }

            if(item.attributes.tolerance_length_plus && item.attributes.tolerance_length_plus !== this.defaultItem.attributes.tolerance_length_plus){
              this.defaultItem.attributes.tolerance_length_plus = cloneDeep(item.attributes.tolerance_length_plus);
              item.attributes.tolerance_length_plus = this.inchToMilimeters(item.attributes.tolerance_length_plus);
            }else{
              delete item.attributes.tolerance_length_plus;
            }

            if(item.attributes.tolerance_length_minus && item.attributes.tolerance_length_minus !== this.defaultItem.attributes.tolerance_length_minus){
              this.defaultItem.attributes.tolerance_length_minus = cloneDeep(item.attributes.tolerance_length_minus);
              item.attributes.tolerance_length_minus = this.milimetersToInch(item.attributes.tolerance_length_minus);
            }else{
              delete item.attributes.tolerance_length_minus;
            }

            if(item.attributes.tolerance_height_plus && item.attributes.tolerance_height_plus !== this.defaultItem.attributes.tolerance_height_plus){
              this.defaultItem.attributes.tolerance_height_plus = cloneDeep(item.attributes.tolerance_height_plus);
              item.attributes.tolerance_height_plus = this.milimetersToInch(item.attributes.tolerance_height_plus);
            }else{
              delete item.attributes.tolerance_height_plus;
            }

            if(item.attributes.tolerance_height_minus && item.attributes.tolerance_height_minus !== this.defaultItem.attributes.tolerance_height_minus){
              this.defaultItem.attributes.tolerance_height_minus = cloneDeep(item.attributes.tolerance_height_minus);
              item.attributes.tolerance_height_minus = this.milimetersToInch(item.attributes.tolerance_height_minus);
            }else{
              delete item.attributes.tolerance_height_minus;
            }
        }
        
      this.axios
        .put("bundlegroups/" + item.id, item)
        .then((res) => {
          this.$store.dispatch("setSnackbar", { text: this.$t("GLOBAL-MESSAGE-SUCCESSFULLY_SAVED") });
        })
        .catch((err) => {
          this.$store.dispatch("setSnackbar", { text: this.$t("GLOBAL-MESSAGE-ERROR") + ": " + err.response.data.message, type: "error" });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
